import OutsideClickComponent from "../fragments/OutsideClickComponent";
import Button from "./Button";

import classes from './RemoveDataConfirmationModal.module.css'

export default function RemoveDataConfirmationModal({closeModal, removeData, position, message, confirmLabel}) {
    return <>
        <OutsideClickComponent task={closeModal}>
            <div className={`${classes.container} ${position ? classes[position] : ''}` }>
                {message
                    ? <p>{message}</p>
                    : <p>
                        Are you sure,
                        <br />
                        you want to remove this?
                    </p>
                }
                <div className={classes.footer}>
                    <Button click={closeModal} btnStyle={'btn_small'}>Cancel</Button>
                    <Button click={removeData} color={'btn_danger'} btnStyle={'btn_small'}>{confirmLabel || 'Remove'}</Button>
                </div>
            </div>
        </OutsideClickComponent>        
    </>
}